"use client";
import { useEffect } from "react";
import { CONSENT_UPDATED_EVENT,readTrackingConsentSnapshot } from "@/lib/consent/client";
import { attributionFromSearchParams } from "@/lib/marketing/readme-referral-attribution";
export default function IncomingAttribution() {
 useEffect(()=>{
  const params=new URLSearchParams(window.location.search);
  const attribution=attributionFromSearchParams(params);

  let recorded=false;
  const capture=(event?:Event)=>{
   const consent=event instanceof CustomEvent?event.detail?.analytics_tracking:readTrackingConsentSnapshot()?.analytics_tracking;
   if(consent===false){recorded=false;void fetch("/api/marketing/attribution",{method:"DELETE",keepalive:true});return;}
   if(!attribution || recorded || consent!==true) return;
   recorded=true;
   void fetch("/api/marketing/attribution",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({slug:attribution.slug,consent:true}),keepalive:true}).then(response=>{if(!response.ok)recorded=false;}).catch(()=>{recorded=false;});
  };
  capture();window.addEventListener(CONSENT_UPDATED_EVENT,capture);
  return()=>window.removeEventListener(CONSENT_UPDATED_EVENT,capture);
 },[]);
 return null;
}
